import { Icon } from '@/component/atoms/Icon'
import React from 'react'
import { S } from './RequiredConfirmModal.style'

const POSTER_URL = 'https://colorate.azurewebsites.net/SwatchColor/E8E8E8'

type Props = {
  onPrev?: () => void
  onNext: () => void
  title: React.ReactNode
  description: React.ReactNode
  hasPrevButton?: boolean
  nextButtonText?: string
  prevButtonText?: string
  videoUrl: string
}

const GuideStepModal = ({
  onPrev,
  onNext,
  title,
  description,
  hasPrevButton = false,
  nextButtonText = '다음',
  prevButtonText = '이전',
  videoUrl,
}: Props) => {
  return (
    <S.MainStep>
      <div className="video-wrapper">
        <video src={videoUrl} autoPlay loop className="video" poster={POSTER_URL} controls />
      </div>
      <div className="text-section">
        <div className="title">{title}</div>
        <p className="description">{description}</p>
      </div>

      {/* 교체할 버튼 */}
      <div className="button-section">
        {hasPrevButton && (
          <button className="prev-button" onClick={onPrev}>
            <Icon
              name="navigation_arrow_back"
              className="arrow-icon"
              color="var(--Colors-Gray-800)"
            />
            <div className="text">{prevButtonText}</div>
          </button>
        )}
        <button className="next-button" onClick={onNext}>
          <div className="text">{nextButtonText}</div>
          <Icon name="navigation_arrow_right" className="arrow-icon" />
        </button>
      </div>
    </S.MainStep>
  )
}

export default GuideStepModal
